import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import PaymentCard from '../PaymentCard';
import { paymentTypes } from '../../data/payment-types';
var defaultProps = {};
export default function PaymentOptions(_ref) {
  var onPlanSelected = _ref.onPlanSelected,
      plans = _ref.plans;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    className: "modal-content payment-cards",
    stackable: true,
    columns: plans.length,
    verticalAlign: "bottom"
  }, plans.map(function (plan) {
    var index = paymentTypes.findIndex(function (paymentType) {
      return paymentType.title === plan.title;
    });
    return /*#__PURE__*/React.createElement(Grid.Column, {
      className: "payment-column",
      key: index
    }, /*#__PURE__*/React.createElement(PaymentCard, _extends({}, plan, {
      onPlanSelected: onPlanSelected,
      index: index
    })));
  })));
}
PaymentOptions.defaultProps = defaultProps;